import { useState } from 'react';

export function useUniqueId(): string {
  return useState(() => Date.now().toString(36) + Math.random().toString(36).slice(1))[0];
}
